type Lang = 'en' | 'ar' | 'fr';

/**
 * Helper to return text for the current language, with French falling back to English.
 */
export const localText = (lang: Lang, en: string, ar: string, fr?: string): string =>
  lang === 'ar' ? ar : lang === 'fr' ? (fr || en) : en;
